module.exports = __webpack_public_path__ + "static/media/QIMRB.6e7074d6.png";